import { NewsInterface } from '../../../interfaces/news.interface';

export default [] as NewsInterface[];
